var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.path } },
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("contacts")))]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      label: _vm.$ct("default-payment-days"),
                                      decimals: 0,
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.config.DefaultPaymentDays,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "DefaultPaymentDays",
                                          $$v
                                        )
                                      },
                                      expression: "config.DefaultPaymentDays",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "default-discount-cash-days"
                                      ),
                                      decimals: 0,
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.config.DefaultDiscountCashDays,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "DefaultDiscountCashDays",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.DefaultDiscountCashDays",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                [
                                  _c("app-country-code-autocomplete", {
                                    attrs: {
                                      label: _vm.$ct("default-country"),
                                      open: true,
                                      ucfirst: "",
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.config.DefaultCountry,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "DefaultCountry",
                                          $$v
                                        )
                                      },
                                      expression: "config.DefaultCountry",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                [
                                  _c("app-sell-price-category-select", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "default-sell-price-category"
                                      ),
                                      "use-number": "",
                                      fancy: "",
                                      "add-empty-value": "",
                                    },
                                    model: {
                                      value:
                                        _vm.config
                                          .DefaultSellPriceCategoryForNewClients,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "DefaultSellPriceCategoryForNewClients",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.DefaultSellPriceCategoryForNewClients",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                [
                                  _c("w-select", {
                                    staticClass: "mts",
                                    attrs: {
                                      items: _vm.extraFieldNames,
                                      label: _vm.$ct(
                                        "fostplus-check-extra-field"
                                      ),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.config.FostplusCheckExtraField,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "FostplusCheckExtraField",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.FostplusCheckExtraField",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "check-for-duplicate-address"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.config.CheckForDuplicateAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "CheckForDuplicateAddress",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.CheckForDuplicateAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "auto-complete-contact-address"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.config.AutoCompleteContactAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "AutoCompleteContactAddress",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.AutoCompleteContactAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("contact-select-vat-id"),
                                    },
                                    model: {
                                      value: _vm.config.ContactSelectVatID,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "ContactSelectVatID",
                                          $$v
                                        )
                                      },
                                      expression: "config.ContactSelectVatID",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("show-bank-on-contact"),
                                    },
                                    model: {
                                      value: _vm.config.ShowBankOnContact,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "ShowBankOnContact",
                                          $$v
                                        )
                                      },
                                      expression: "config.ShowBankOnContact",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      value:
                                        !_vm.userConfig
                                          .NewCustommersAreBuisinessesByDefault,
                                      label: _vm.$ct(
                                        "new-custommers-are-buisinesses-by-default"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.userConfig.NewCustommersAreBuisinessesByDefault =
                                          !$event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }